<template>
  <div class="">
    <!-- {{ validationObj }} -->
    <div class="error-container" v-if="hasErrors">
      <div v-for="(error, index) in errors" :key="index">
        <span class="color-red">
          {{ getErrorMessage(error) }}
          <br />
        </span>
      </div>

      <!-- Custom Error Message -->
      <span v-if="customError" class="color-red">
        {{ customError }}
        <br />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormError",
  props: {
    validationObj: {
      type: Object,
      default: () => ({}),
    },
    customError: {
      type: String,
      default: "",
    },
  },
  computed: {
    hasErrors() {
      return (
        (this.validationObj?.$error && this.errors.length > 0) ||
        this.customError
      );
    },
    errors() {
      if (!this.validationObj?.$errors) return [];
      return this.validationObj.$errors;
    },
  },
  methods: {
    getErrorMessage(error) {
      const validatorType = error.$validator;
      const params = error.$params;

      switch (validatorType) {
        case "required":
          return "هذا الحقل مطلوب";
        case "minLength":
          return `هذا الحقل يجب ان يكون بحد الادني ${params.min} ارقام`;
        case "maxLength":
          return `هذا الحقل يجب ان لا يتجاوز ${params.max} حرف`;
        case "numeric":
          return "هذا الحقل يجب أن يحتوي على أرقام فقط";
        case "alpha":
          return "هذا الحقل يجب أن يحتوي على حروف عربيه والانجليزيه فقط";
        case "beta":
          return "هذا الحقل غير صحيح";
        case "maxVal":
          return `هذا الحقل يجب ان لا يتجاوز ${params.max / 1000000} ميجا`;
        case "eta":
          return "هذا الحقل يحتوي على ارقام فقط والرموز الاتيه /-";
        case "exact":
          return `هذا الحقل يجب أن يكون ${params.length} أرقام`;
        case "validType":
          return `الملفات المسموح بها فقط JPG, JPEG, PNG, PDF`;
        case "beforeOrEqualToday":
          return "يجب أن يكون هذا التاريخ  قبل أو يساوي تاريخ اليوم";
        case "positiveNumbers":
          return "يقبل ارقام صحيحة وموجبة فقط";
        default:
          return error.$message || "حدث خطأ";
      }
    },
  },
};
</script>

<style scoped>
.color-red {
  color: #dc3545;
  font-size: 0.875rem;
}

.error-container {
  margin-top: 0.25rem;
}
</style>
